import Layout from "@/pages/Layout/Layout.vue";
import Layoutone from "@/pages/Layout/Layoutone.vue";
import Xisobot from "@/pages/Layout/Xisobot.vue";
const Chiqimcreate = () => import("@/pages/Chiqim/Create.vue");
const Bron = () => import("@/pages/Bron/Index.vue");
const routes = [
  {
    path: "/",
    component: () => import("@/pages/Layout/DashboardLayout.vue"),
    redirect: "/login",
    children: [
      {
        path: "/",
        name: "Бош сахифа",
        component: () => import("@/pages/Dashboard.vue")
      },
      {
        path: "/zakazlar/index",
        name: "Zakazlar",
        component: () => import("@/pages/Zakazlar/Index.vue")
      },
      {
        path: "/zakazlar/form",
        name: "Zakazlar Form",
        component: () => import("@/pages/Zakazlar/Form.vue")
      },
      {
        path: "/nasiyalar",
        name: "Nasiyalar",
        component: () => import("@/pages/Nasiyalar/Index.vue")
      },
      {
        path: "/ombor",
        name: "Ombor",
        component: () => import("@/pages/Ombor/Index.vue")
      },
      {
        path: "/xisobot/main",
        name: "Хисоботлар",
        component: () => import("@/pages/Xisobot/Index.vue")
      },
      {
        path: "/kirim/index",
        name: "Кирим",
        component: () => import("@/pages/Kirim/Index.vue")
      },
      {
        path: "/convertion/index",
        name: "Конверсия",
        component: () => import("@/pages/Convertion/Index.vue")
      },
      {
        path: "/write-off/index",
        name: "Списания",
        component: () => import("@/pages/Writeoff/Index.vue")
      },
      {
        path: "/refund/index",
        name: "Возврат",
        component: () => import("@/pages/Refund/Index.vue")
      },
      {
        path: "/kontragentinitial/index",
        name: "Kontragentinitial",
        component: () => import("@/pages/Kontragentinitial/Index.vue")
      },
      {
        path: "/refundsuplier/index",
        name: "Возврат поставшик",
        component: () => import("@/pages/Refundsuplier/Index.vue")
      },
      {
        path: "/chiqim/index",
        name: "Чиқим",
        component: () => import("@/pages/Chiqim/index.vue")
      },
      {
        path: "/chiqim/pos",
        name: "Savdo POS",
        component: () => import("@/pages/Chiqim/Pos.vue")
      },
      {
        path: "/kassaorder/index",
        name: "Кассовий ордер",
        component: () => import("@/pages/Kassaorder/Index.vue")
      },
      {
        path: "/oplata/index",
        name: "Тўлов",
        component: () => import("@/pages/Oplata/Index.vue")
      },
      {
        path: "/revision/index",
        name: "Ревизия",
        component: () => import("@/pages/Revision/Index.vue")
      },
      {
        path: "/calculation/index",
        name: "Калкулация",
        component: () => import("@/pages/Calculation/Index.vue")
      },
      {
        path: "/salary/index",
        name: "Маош хисоблаш",
        component: () => import("@/pages/Salary/Index.vue")
      },
      {
        path: "/prixod/index",
        name: "Prixod",
        component: () => import("@/pages/Prixod/Index.vue")
      },
      {
        path: "/production/index",
        name: "Ишлаб чиқариш",
        component: () => import("@/pages/Production/Index.vue")
      },
      {
        path: "/transfer/index",
        name: "Перемешения",
        component: () => import("@/pages/Transfer/Index.vue")
      },
      {
        path: "/paket/index",
        name: "Paketlar",
        component: () => import("@/pages/Paketlar/Index.vue")
      },
      {
        path: "/brand/index",
        name: "Brendlar",
        component: () => import("@/pages/Malumot/Brand/Index.vue")
      },
      {
        path: "/pay-type/index",
        name: "Tolov turlari",
        component: () => import("@/pages/Malumot/PayType/Index.vue")
      },
      {
        path: "/taminotchi/index",
        name: "Ta'minotchi",
        component: () => import("@/pages/Malumot/Taminotchi/Index.vue")
      },
      {
        path: "/malumot/taminotchi/update/:id",
        name: "Taminotchini ўзгартириш",
        component: () => import("@/pages/Malumot/Taminotchi/Update.vue")
      },
      {
        path: "/malumot/taminotchi/create",
        name: "Taminotchi qoshish",
        component: () => import("@/pages/Malumot/Taminotchi/Create.vue")
      },
      {
        path: "/model/index",
        name: "Modellar",
        component: () => import("@/pages/Malumot/Model/Index.vue")
      },
      {
        path: "/product-brand-model/index",
        name: "Mahsulot Brand/Model",
        component: () => import("@/pages/Malumot/ProductBrandModel/Index.vue")
      },
      {
        path: "/xisobot/staff-sales",
        name: "Xodimlar Savdosi Reytingi",
        component: () => import("@/pages/Xisobot/StaffSales/Index.vue")
      },
      {
        path: "/xisobot/profit-detail",
        name: "Foyda-Zarar Hisoboti",
        component: () => import("@/pages/Xisobot/ProfitDetail/Index.vue")
      },
      {
        path: "/salary/balance",
        name: "Xodimlar Balansi",
        component: () => import("@/pages/Salary/Balance/Index.vue")
      },
      {
        path: "/xisobot/dashboard",
        name: "Hisobotlar",
        component: () => import("@/pages/Xisobot/Dashboard.vue")
      },
      {
        path: "/revision/quick",
        name: "Tezkor Revizya",
        component: () => import("@/pages/Revision/Quick/Index.vue")
      },
      {
        path: "/xisobot/products-inventory",
        name: "Mahsulotlar Hisoboti",
        component: () => import("@/pages/Xisobot/ProductsInventory/Index.vue")
      },
      {
        path: "/xisobot/kassa-summary",
        name: "Kassa Hisoboti",
        component: () => import("@/pages/Xisobot/KassaSummary/Index.vue")
      },
      {
        path: "/paket/form",
        name: "PaketYaratish",
        component: () => import("@/pages/Paketlar/Form.vue")
      },
      {
        path: "/paket/edit/:id",
        name: "PaketTahrirlash",
        component: () => import("@/pages/Paketlar/Form.vue")
      },
      {
        path: "/usta/index",
        name: "Ustalar",
        component: () => import("@/pages/Ustalar/Index.vue")
      },
      {
        path: "/usta/give-product",
        name: "Ustaga sovg'a",
        component: () => import("@/pages/Ustalar/GiveProduct.vue")
      },
      {
        path: "/aksiya/index",
        name: "Aksiyalar",
        component: () => import("@/pages/Aksiya/Index.vue")
      },
      {
        path: "/xarajatlar/index",
        name: "Xarajatlar",
        component: () => import("@/pages/Xarajatlar/Index.vue")
      },
      {
        path: "/money-transfer/index",
        name: "Перемешения касса",
        component: () => import("@/pages/Moneytransfer/Index.vue")
      },
      {
        path: "/user_pay/index",
        name: "Ходимга тўлов",
        component: () => import("@/pages/User_pay/Index.vue")
      },
      {
        path: "/initial/index",
        name: "Начальный остаток",
        component: () => import("@/pages/Initial/Index.vue")
      },
      {
        path: "/malumot/product/index",
        name: "Товар",
        component: () => import("@/pages/Malumot/Product/Index.vue")
      },
      {
        path: "/malumot/sklad/index",
        name: "Склад",
        component: () => import("@/pages/Malumot/Sklad/Index.vue")
      },
      {
        path: "/malumot/user/index",
        name: "Фойдаланувчи",
        component: () => import("@/pages/Malumot/User/Index.vue")
      },
      {
        path: "/malumot/kontragent/index",
        name: "Контрагент",
        component: () => import("@/pages/Malumot/Kontragent/Index.vue")
      },
      {
        path: "/malumot/crm-client/index",
        name: "Crm",
        component: () => import("@/pages/Malumot/CrmClient/Index.vue")
      },
      {
        path: "/malumot/staff/index",
        name: "Staff",
        component: () => import("@/pages/Malumot/Staff/Index.vue")
      },
      {
        path: "/malumot/dollar/index",
        name: "Dollar",
        component: () => import("@/pages/Malumot/Dollar/Index.vue")
      },
      {
        path: "/malumot/panel/index",
        name: "Panel",
        component: () => import("@/pages/Malumot/Panel/Index.vue")
      },

      {
        path: "/contact",
        name: "Aloqa uchun",
        component: () => import("@/pages/Malumot/Contact/Index.vue")
      },
      {
        path: "/offers",
        name: "Offers",
        component: () => import("@/pages/Malumot/Offer/Index.vue")
      },
      {
        path: "/directory/product/index",
        name: "Товар модал",
        // component: Product
        component: () => import("@/pages/Directory/Product/Index.vue")
      },
      {
        path: "/directory/product/create",
        name: "Товар модал create",
        component: () => import("@/pages/Directory/Product/Create.vue")
      },
      {
        path: "/directory/product/update/:id",
        name: "Товар модал update",
        component: () => import("@/pages/Directory/Product/Update.vue")
      }
    ]
  },
  {
    path: "/",
    component: Xisobot,
    redirect: "/login",
    children: [
      {
        path: "/xisobot/sverka/product/:product/:sklad/:date1/:date2",
        name: "Товар сверкаси",
        component: () => import("@/pages/Xisobot/Sverka/Product.vue")
      },
      {
        path:
          "/xisobot/sverka/kontragent/:kontragent/:sklad/:date1/:date2/:price",
        name: "Ходим сверкаси",
        component: () => import("@/pages/Xisobot/Sverka/Kontragent.vue")
      },
      {
        path: "/xisobot/sverka/user/:user/:sklad/:date1/:date2",
        name: "Ходим сверкаси",
        component: () => import("@/pages/Xisobot/Sverka/User.vue")
      },
      {
        path: "/xisobot/sverka/kassa",
        name: "Касса сверкаси",
        component: () => import("@/pages/Xisobot/Sverka/Kassa.vue")
      },
      {
        path: "/xisobot/sverka/foyda/:product/:sklad/:date1/:date2",
        name: "Фойда сверкаси",
        component: () => import("@/pages/Xisobot/Sverka/Foyda.vue")
      },
      {
        path: "/xisobot/xisobot/product",
        name: "Товар хисоботи",
        component: () => import("@/pages/Xisobot/Xisobot/Product.vue")
      },
      {
        path: "/xisobot/xisobot/rasxod",
        name: "Кунлик айланма",
        component: () => import("@/pages/Xisobot/Xisobot/Rasxod.vue")
      },
      {
        path: "/xisobot/xisobot/balance",
        name: "Баланс",
        component: () => import("@/pages/Xisobot/Xisobot/Balance.vue")
      },
      {
        path: "/xisobot/xisobot/xarajat",
        name: "Харажат хисобот",
        component: () => import("@/pages/Xisobot/Xisobot/Xarajat.vue")
      },
      {
        path: "/xisobot/xisobot/foyda",
        name: "Фойда хисоботи",
        component: () => import("@/pages/Xisobot/Xisobot/Foyda.vue")
      },
      {
        path: "/xisobot/xisobot/kontragent",
        name: "Контрагент хисоботи",
        component: () => import("@/pages/Xisobot/Xisobot/Kontragent.vue")
      },
      {
        path: "/xisobot/xisobot/kontragentpos",
        name: "Контрагент хисоботи",
        component: () => import("@/pages/Xisobot/Xisobot/Kontragentpos.vue")
      },
      {
        path: "/xisobot/xisobot/user",
        name: "Ходим хисоботи",
        component: () => import("@/pages/Xisobot/Xisobot/User.vue")
      },
      {
        path: "/xisobot/xisobot/kassa",
        name: "Касса хисоботи",
        component: () => import("@/pages/Xisobot/Xisobot/Kassa.vue")
      },
      {
        path: "/xisobot/xisobot/product_abc",
        name: "Товар абс",
        component: () => import("@/pages/Xisobot/Xisobot/Product_abc.vue")
      },
      {
        path: "/xisobot/xisobot/rester_kirim",
        name: "Приход рестер",
        component: () => import("@/pages/Xisobot/Rester/Kirim.vue")
      },
      {
        path: "/xisobot/xisobot/rester_initial",
        name: "Бошланғич қолдиқ рестер",
        component: () => import("@/pages/Xisobot/Rester/Initial.vue")
      },
      {
        path: "/xisobot/xisobot/rester_chiqim",
        name: "Продажа рестер",
        component: () => import("@/pages/Xisobot/Rester/Chiqim.vue")
      },
      {
        path: "/xisobot/xisobot/rester_oplata",
        name: "Оплата рестер",
        component: () => import("@/pages/Xisobot/Rester/Oplata.vue")
      },
      {
        path: "/xisobot/xisobot/rester_refund",
        name: "Возврат рестер",
        component: () => import("@/pages/Xisobot/Rester/Refund.vue")
      },
      {
        path: "/xisobot/xisobot/rester_refund_suplier",
        name: "Возврат поставшик рестер",
        component: () => import("@/pages/Xisobot/Rester/Refund_suplier.vue")
      },
      {
        path: "/xisobot/xisobot/rester_transfer",
        name: "Перемешения рестер",
        component: () => import("@/pages/Xisobot/Rester/Transfer.vue")
      },
      {
        path: "/xisobot/xisobot/rester_writeoff",
        name: "Cписания рестер",
        component: () => import("@/pages/Xisobot/Rester/Writeoff.vue")
      }
    ]
  },
  {
    path: "/",
    component: Layoutone,
    redirect: "/",
    children: [
      {
        path: "/sendsms",
        name: "Sendsms",
        component: () => import("@/pages/Sendsms.vue")
      },
      {
        path: "/sendsecretcodes",
        name: "Sendsecretcodes",
        component: () => import("@/pages/Sendsecretcodes.vue")
      },
      {
        path: "/registration",
        name: "Registration",
        component: () => import("@/pages/Registration.vue")
      },
      {
        path: "/registerbase/:number",
        name: "Registerbase",
        component: () => import("@/pages/Registrationbase.vue")
      },
      {
        path: "/smsaccept/:code",
        name: "Smsaccept",
        component: () => import("@/pages/Smsaccept.vue")
      },
      {
        path: "/smsacceptback/:code/:hostname",
        name: "Smsacceptback",
        component: () => import("@/pages/Smsacceptback.vue")
      },
      {
        path: "/programmersms/:phone",
        name: "Programmersms",
        component: () => import("@/pages/Programmersms.vue")
      },
      {
        path: "/baseurl",
        name: "Baseurl",
        component: () => import("@/pages/Baseurl.vue")
      },
      {
        path: "/login",
        name: "Login",
        component: () => import("@/pages/Login.vue")
      }
    ]
  },
  {
    path: "/kirim/barcode/:id",
    name: "barcodeprixod",
    component: () => import("@/pages/Kirim/Barcode.vue")
  },
  {
    path: "/transfer/barcode/:id",
    name: "barcodetransfer",
    component: () => import("@/pages/Transfer/Barcode.vue")
  },
  {
    path: "/product/barcode",
    name: "barcodeproduct",
    component: () => import("@/pages/Malumot/Product/Barcode.vue")
  },
  {
    path: "/initial/barcode/:id",
    name: "barcodeinitial",
    component: () => import("@/pages/Initial/Barcode.vue")
  },
  {
    path: "/kirim/barcodeone/:id",
    name: "barcodeprixodone",
    component: () => import("@/pages/Kirim/Barcodeone.vue")
  },
  {
    path: "/",
    component: Layout,
    redirect: "/login",
    children: [
      {
        path: "/calculation/update/:id",
        name: "Калкулация update",
        component: () => import("@/pages/Calculation/Update.vue")
      },
      {
        path: "/calculation/create",
        name: "Калкулация create",
        component: () => import("@/pages/Calculation/Create.vue")
      },
      {
        path: "/salary/update/:id",
        name: "Маош хисоблаш ўзгартириш",
        component: () => import("@/pages/Salary/Update.vue")
      },
      {
        path: "/salary/create",
        name: "Маош хисоблаш қўшиш",
        component: () => import("@/pages/Salary/Create.vue")
      },
      {
        path: "/user_pay/create",
        name: "Ходимга тўлов қўшиш",
        component: () => import("@/pages/User_pay/Create.vue")
      },
      {
        path: "/user_pay/update/:id",
        name: "Ходимга тўлов ўзгартириш",
        component: () => import("@/pages/User_pay/Update.vue")
      },
      {
        path: "/convertion/update/:id",
        name: "Конверсия ўзгартириш",
        component: () => import("@/pages/Convertion/Update.vue")
      },
      {
        path: "/convertion/create",
        name: "Convertion create",
        component: () => import("@/pages/Convertion/Create.vue")
      },
      {
        path: "/production/create",
        name: "Ишлаб чиқариш create",
        component: () => import("@/pages/Production/Create.vue")
      },

      {
        path: "/production/update/:id",
        name: "Ишлаб чиқариш ўзгартириш",
        component: () => import("@/pages/Production/Update.vue")
      },

      {
        path: "/initial/create",
        name: "Initial qoshish",
        component: () => import("@/pages/Initial/Create.vue")
      },
      {
        path: "/revision/create",
        name: "Revision qoshish",
        component: () => import("@/pages/Revision/Create.vue")
      },
      {
        path: "/revision/update/:id",
        name: "Ревизия ўзгартириш ",
        component: () => import("@/pages/Revision/Update.vue")
      },
      {
        path: "/revision/jamlash/update/:id",
        name: "Ревизия ўзгартириш",
        component: () => import("@/pages/Revision/Updatereal.vue")
      },
      {
        path: "/kontragentinitial/create",
        name: "Kontragentinitial qoshish",
        component: () => import("@/pages/Kontragentinitial/Create.vue")
      },
      {
        path: "/kontragentinitial/update/:id",
        name: "Kontragentinitial ўзгартириш",
        component: () => import("@/pages/Kontragentinitial/Update.vue")
      },
      {
        path: "/revision/jamlash/create",
        name: "Ревизия",
        component: () => import("@/pages/Revision/Createreal.vue")
      },
      {
        path: "/transfer/update/:id",
        name: "Перевод ўзгартириш",
        component: () => import("@/pages/Transfer/Update.vue")
      },
      {
        path: "/transfer/create",
        name: "Transfercreate",
        component: () => import("@/pages/Transfer/Create.vue")
      },
      {
        path: "/money-transfer/update/:id",
        name: "Перевод денег ўзгартириш",
        component: () => import("@/pages/Moneytransfer/Update.vue")
      },
      {
        path: "/money-transfer/create",
        name: "MoneyTransfercreate",
        component: () => import("@/pages/Moneytransfer/Create.vue")
      },
      {
        path: "/initial/update/:id",
        name: "Начальный остаток ўзгартириш",
        component: () => import("@/pages/Initial/Update.vue")
      },
      {
        path: "/initial/a4print/:id",
        name: "a4printinitial",
        component: () => import("@/pages/Initial/A4Print.vue")
      },
      {
        path: "/chiqim/create",
        name: "Chiqim qoshish",
        component: () => import("@/pages/Chiqim/Create.vue")
      },

      {
        path: "/chiqim/bronlist",
        name: "Chiqim bronlist",
        components: {
          default: Chiqimcreate,
          modals: Bron
        }
      },

      {
        path: "/chiqim/update/:id",
        name: "Чиқим ўзгартириш",
        component: () => import("@/pages/Chiqim/Update.vue")
      },
      {
        path: "/write-off/update/:id",
        name: "Списания ўзгартириш",
        component: () => import("@/pages/Writeoff/Update.vue")
      },
      {
        path: "/write-off/create",
        name: "Списания qoshish",
        component: () => import("@/pages/Writeoff/Create.vue")
      },

      {
        path: "/chiqim/print/:id",
        name: "prints",
        component: () => import("@/pages/Chiqim/Print.vue")
      },
      {
        path: "/chiqim/zreportprint",
        name: "zprints",
        component: () => import("@/pages/Chiqim/ZReportPrint.vue")
      },
      {
        path: "/chiqim/a4print/:id",
        name: "a4print",
        component: () => import("@/pages/Chiqim/A4Print.vue")
      },
      {
        path: "/refund/print/:id",
        name: "printrefund",
        component: () => import("@/pages/Refund/Print.vue")
      },
      {
        path: "/refundsuplier/print/:id",
        name: "printrefundsuplier",
        component: () => import("@/pages/Refundsuplier/Print.vue")
      },
      {
        path: "/refundsuplier/a4print/:id",
        name: "a4printsup",
        component: () => import("@/pages/Refundsuplier/A4Print.vue")
      },
      {
        path: "/kirim/print/:id",
        name: "printprixod",
        component: () => import("@/pages/Kirim/Print.vue")
      },
      {
        path: "/kirim/a4print/:id",
        name: "a4_print",
        component: () => import("@/pages/Kirim/A4Print.vue")
      },
      {
        path: "/transfer/print/:id",
        name: "printtransfer",
        component: () => import("@/pages/Transfer/Print.vue")
      },
      {
        path: "/kassaorder/create",
        name: "Kassaorder qoshish",
        component: () => import("@/pages/Kassaorder/Create.vue")
      },
      {
        path: "/kassaorder/update/:id",
        name: "Кассовий ордер ўзгартириш",
        component: () => import("@/pages/Kassaorder/Update.vue")
      },
      {
        path: "/oplata/create",
        name: "Oplata qoshish",
        component: () => import("@/pages/Oplata/Create.vue")
      },
      {
        path: "/oplata/update/:id",
        name: "Тўлов ўзгартириш",
        component: () => import("@/pages/Oplata/Update.vue")
      },
      {
        path: "/oplata/print/:id",
        name: "Тўлов печат",
        component: () => import("@/pages/Oplata/Print.vue")
      },
      {
        path: "/kirim/create",
        name: "Kirim qoshish",
        component: () => import("@/pages/Kirim/Create.vue")
      },

      {
        path: "/kirim/update/:id",
        name: "Кирим ўзгартириш",
        component: () => import("@/pages/Kirim/Update.vue")
      },
      {
        path: "/refund/create",
        name: "Refund qoshish",
        component: () => import("@/pages/Refund/Create.vue")
      },

      {
        path: "/refund/update/:id",
        name: "Возврат ўзгартириш",
        component: () => import("@/pages/Refund/Update.vue")
      },
      {
        path: "/refundsuplier/create",
        name: "Refund postavshik qoshish",
        component: () => import("@/pages/Refundsuplier/Create.vue")
      },

      {
        path: "/refundsuplier/update/:id",
        name: "Возврат поставщик ўзгартириш",
        component: () => import("@/pages/Refundsuplier/Update.vue")
      },
      {
        path: "/malumot/product/create",
        name: "Product qoshish",
        component: () => import("@/pages/Malumot/Product/Create.vue")
      },
      {
        path: "/malumot/product/update/:id",
        name: "Продукт ўзгартириш",
        component: () => import("@/pages/Malumot/Product/Update.vue")
      },
      {
        path: "/malumot/sklad/create",
        name: "Sklad qoshish",
        component: () => import("@/pages/Malumot/Sklad/Create.vue")
      },
      {
        path: "/malumot/sklad/update/:id",
        name: "Склад ўзгартириш",
        component: () => import("@/pages/Malumot/Sklad/Update.vue")
      },
      {
        path: "/malumot/user/create",
        name: "User qoshish",
        component: () => import("@/pages/Malumot/User/Create.vue")
      },
      {
        path: "/malumot/user/update/:id",
        name: "Узер ўзгартириш",
        component: () => import("@/pages/Malumot/User/Update.vue")
      },
      {
        path: "/malumot/kontragent/create",
        name: "Kontragent qoshish",
        component: () => import("@/pages/Malumot/Kontragent/Create.vue")
      },
      {
        path: "/malumot/kontragent/update/:id",
        name: "Контрагент ўзгартириш",
        component: () => import("@/pages/Malumot/Kontragent/Update.vue")
      },
      {
        path: "/malumot/contact/create",
        name: "Contact qoshish",
        component: () => import("@/pages/Malumot/Contact/Create.vue")
      },
      {
        path: "/malumot/contact/update/:id",
        name: "Contact ўзгартириш",
        component: () => import("@/pages/Malumot/Contact/Update.vue")
      },
      {
        path: "/malumot/crm-client/create",
        name: "CrmClient qoshish",
        component: () => import("@/pages/Malumot/CrmClient/Create.vue")
      },
      {
        path: "/malumot/staff/create",
        name: "Staff qoshish",
        component: () => import("@/pages/Malumot/Staff/Create.vue")
      },
      {
        path: "/malumot/crm-client/update/:id",
        name: "Crm client ўзгартириш",
        component: () => import("@/pages/Malumot/CrmClient/Update.vue")
      },
      {
        path: "/malumot/staff/update/:id",
        name: "Staff ўзгартириш",
        component: () => import("@/pages/Malumot/Staff/Update.vue")
      },
      {
        path: "/malumot/pechat/a4settings",
        name: "Печать",
        component: () => import("@/pages/Malumot/Pechat/A4Settings.vue")
      }
    ]
  }
];
export default routes;
